import { render, staticRenderFns } from "./PrintLabModal.vue?vue&type=template&id=6c809c4e&scoped=true&"
import script from "./PrintLabModal.vue?vue&type=script&lang=js&"
export * from "./PrintLabModal.vue?vue&type=script&lang=js&"
import style0 from "./PrintLabModal.vue?vue&type=style&index=0&id=6c809c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c809c4e",
  null
  
)

export default component.exports